import { z } from '@hono/zod-openapi'

// id
export const idZ = z
  .number()
  .openapi({ description: 'オーナーメモID', example: 1 })
export type id = z.infer<typeof idZ>

// ownerId
export const ownerIdZ = z
  .string()
  .openapi({ description: 'メモ対象のオーナーID', example: 'owner-123' })
export type ownerId = z.infer<typeof ownerIdZ>

// propertyId
export const propertyIdZ = z
  .number()
  .openapi({ description: 'メモ対象の物件ID', example: 101 })
export type propertyId = z.infer<typeof propertyIdZ>

// roomId
export const roomIdZ = z.number().nullable().openapi({
  description: 'メモ対象の部屋ID。null は物件全体に対するメモ',
  example: 1,
})
export type roomId = z.infer<typeof roomIdZ>

// title
export const titleZ = z
  .string()
  .min(1)
  .openapi({ description: 'メモのタイトル', example: 'メモタイトル' })
export type title = z.infer<typeof titleZ>

// body
export const bodyZ = z
  .string()
  .min(1)
  .openapi({ description: 'メモの本文', example: 'メモ本文' })
export type body = z.infer<typeof bodyZ>

// createdAt
export const createdAtStringZ = z.string().openapi({
  description: '作成日時（ISO8601）',
  example: '2024-01-01T00:00:00.000Z',
})
export type createdAtString = z.infer<typeof createdAtStringZ>

export const createdAtDateZ = z
  .date()
  .openapi({ example: '2024-01-01T00:00:00.000Z' })
export type createdAtDate = z.infer<typeof createdAtDateZ>

// updatedAt
export const updatedAtStringZ = z.string().openapi({
  description: '更新日時（ISO8601）',
  example: '2024-01-01T00:00:00.000Z',
})
export type updatedAtString = z.infer<typeof updatedAtStringZ>

export const updatedAtDateZ = z
  .date()
  .openapi({ example: '2024-01-01T00:00:00.000Z' })
export type updatedAtDate = z.infer<typeof updatedAtDateZ>

export const uploadFilesZ = z
  .array(
    z.object({
      path: z.string().openapi({ example: 'tmp/uuid/timestamp' }),
      fileName: z.string().openapi({ example: 'memo-image.png' }),
    }),
  )
  .optional()
  .openapi({ example: [{}] })
export type uploadFiles = z.infer<typeof uploadFilesZ>

export const deleteFileIdsZ = z
  .array(z.number().int())
  .optional()
  .openapi({ example: [1, 2, 3] })
export type deleteFileIds = z.infer<typeof deleteFileIdsZ>
